import { configureStore } from '@reduxjs/toolkit';
import {
  useDispatch,
  useSelector,
  type TypedUseSelectorHook,
} from 'react-redux';

import accountApi from './apis/account-api';
import baseApi from './apis/base-api';
import type customerNetApi from './apis/cnet-api';
import propertyChangeListenerMiddleware from './middlewares/property-change-listener-middleware';
import authSlice from './slices/auth-slice';
import cartSlice from './slices/cart-slice';
import comparisonSlice from './slices/comparison-slice';
import drawerSlice from './slices/drawer-slice';
import packageSlice from './slices/package-slice';
import uiSlice from './slices/ui-slice';

const store = configureStore({
  reducer: {
    [uiSlice.reducerPath]: uiSlice.reducer,
    [authSlice.reducerPath]: authSlice.reducer,
    [cartSlice.reducerPath]: cartSlice.reducer,
    [comparisonSlice.reducerPath]: comparisonSlice.reducer,
    [baseApi.reducerPath]: accountApi.reducer,
    [drawerSlice.reducerPath]: drawerSlice.reducer,
    [packageSlice.reducerPath]: packageSlice.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .prepend(propertyChangeListenerMiddleware)
      .concat(baseApi.middleware),
});

export type AppRootState = ReturnType<typeof store.getState> & {
  [baseApi.reducerPath]: ReturnType<typeof accountApi.reducer> &
    ReturnType<typeof customerNetApi.customer.reducer> &
    ReturnType<typeof customerNetApi.product.reducer> &
    ReturnType<typeof customerNetApi.springBoot.reducer> &
    ReturnType<typeof customerNetApi.user.reducer>;
};
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<AppRootState> = useSelector;
export default store;
